import { Component, Input } from '@angular/core';

@Component({
  selector: 'kng-icon-button',
  templateUrl: './kng-icon-button.component.html',
  styleUrls: []
})
export class KngIconButtonComponent {

  /**
   * Set to `true` to render the icon button in a disabled state.
   */
  @Input()
  public disabled: boolean;

  /**
   * CSS class containing icon content.
   */
  @Input()
  public icon: string;

  /**
   * Set to `true` to render the icon button in a messaging only state.
   */
  @Input()
  public message: string;

  /**
   * The type of icon button to display.  This can be `horizontal` or `vertical`; defaults to `vertical`.
   */
  @Input()
  public type: string;


  constructor() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-icon-button/kng-icon-button.component.ts